import { render, staticRenderFns } from "./promotionDetail.vue?vue&type=template&id=c5578094&scoped=true"
import script from "./promotionDetail.vue?vue&type=script&lang=js"
export * from "./promotionDetail.vue?vue&type=script&lang=js"
import style0 from "./promotionDetail.vue?vue&type=style&index=0&id=c5578094&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5578094",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TablePromotion: require('/drone/src/components/TablePromotion/index.vue').default})
